var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-player",staticStyle:{"position":"relative"}},[_c('audio',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"audo",attrs:{"src":_vm.clip}}),_c('button',{on:{"click":_vm.playAudo}},[(_vm.isMuted)?_c('MuteIcon'):_c('MusicIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }